// v2.19.22e-1 — Schemas déclaratifs pour DirectoryCrudTab.
export const COMMUNES_CIV = [
  "Cocody", "Plateau", "Yopougon", "Marcory", "Treichville",
  "Adjamé", "Abobo", "Koumassi", "Port-Bouët", "Riviera", "Bingerville",
];

export const SHOPPING_CATS = [
  "food", "cuisine", "art_deco", "vet_homme", "vet_femme", "vet_enfant",
  "chaussures", "bijoux", "quincaillerie", "electromenager", "tech", "beaute",
  "supermarche", "marche", "pharmacie_para", "papeterie", "jouets", "sport",
  "auto", "agro",
];

export const FINANCE_CATS = [
  "banques", "mobile_money", "microcredit", "bourse", "assurance",
  "forex", "epargne", "credit_immo",
];

export const ADMIN_CATS = [
  "identite", "entreprise", "immobilier", "vehicule", "etat_civil",
  "casier", "fiscal", "voyage", "mairie", "commissariat",
  "service_administratif", "ambassade",
];

export const SHOPPING_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "category_id", label: "Catégorie", type: "select", options: SHOPPING_CATS, required: true },
  { key: "name", label: "Nom", type: "text", required: true, maxLength: 80 },
  { key: "tagline", label: "Tagline", type: "text", maxLength: 120 },
  { key: "commune", label: "Commune", type: "select", options: COMMUNES_CIV, required: true },
  { key: "quartier", label: "Quartier", type: "text" },
  { key: "address", label: "Adresse", type: "text" },
  { key: "phone", label: "Téléphone", type: "text", placeholder: "+225 0X XX XX XX XX" },
  { key: "whatsapp", label: "WhatsApp", type: "text" },
  { key: "tags", label: "Tags (CSV)", type: "csv" },
  { key: "rating", label: "Rating", type: "number", min: 0, max: 5, step: 0.1 },
  { key: "price_range", label: "Prix", type: "select", options: ["₣", "₣₣", "₣₣₣", "₣₣₣₣"] },
  { key: "hours", label: "Horaires", type: "text" },
  { key: "photo_url", label: "Photo URL", type: "text" },
  { key: "usp", label: "USP", type: "textarea" },
];

export const FINANCE_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "category", label: "Catégorie", type: "select", options: FINANCE_CATS, required: true },
  { key: "name", label: "Nom", type: "text", required: true, maxLength: 100 },
  { key: "type", label: "Type", type: "text" },
  { key: "commune_name", label: "Commune", type: "select", options: COMMUNES_CIV, required: true },
  { key: "location_text", label: "Adresse", type: "text" },
  { key: "description_short", label: "Description courte", type: "text", maxLength: 200 },
  { key: "description_full", label: "Description complète", type: "textarea" },
  { key: "rate_display", label: "Taux affiché", type: "text" },
  { key: "interest_rate_min", label: "Taux min (%)", type: "number", min: 0, max: 100, step: 0.1 },
  { key: "interest_rate_max", label: "Taux max (%)", type: "number", min: 0, max: 100, step: 0.1 },
  { key: "phone", label: "Téléphone", type: "text" },
  { key: "website", label: "Site web", type: "text" },
  { key: "app_url", label: "URL App", type: "text" },
  { key: "photo_url", label: "Photo URL", type: "text" },
  { key: "usp", label: "USP", type: "textarea" },
];

export const ADMIN_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "category", label: "Catégorie", type: "select", options: ADMIN_CATS, required: true },
  { key: "service_name", label: "Nom du service", type: "text", required: true, maxLength: 120 },
  { key: "organism", label: "Organisme", type: "text" },
  { key: "commune_name", label: "Commune", type: "select", options: COMMUNES_CIV, required: true },
  { key: "location_text", label: "Adresse", type: "text" },
  { key: "description_short", label: "Description courte", type: "text", maxLength: 200 },
  { key: "description_full", label: "Description complète", type: "textarea" },
  { key: "cost_display", label: "Coût (affiché)", type: "text" },
  { key: "cost_fcfa", label: "Coût (FCFA)", type: "number", min: 0 },
  { key: "duration", label: "Durée", type: "text" },
  { key: "documents_required", label: "Documents requis (CSV)", type: "csv" },
  { key: "phone", label: "Téléphone", type: "text" },
  { key: "website", label: "Site web", type: "text" },
  { key: "online_url", label: "URL en ligne", type: "text" },
  { key: "photo_url", label: "Photo URL", type: "text" },
  { key: "usp", label: "USP", type: "textarea" },
];

// ─── v2.19.22e-2 — Hiérarchiques aplatis (catégories réelles d'après distinct Mongo)
export const HEALTH_CATS = [
  "urgence_24_24", "hopitaux_publics", "cliniques_privees",
  "cardiologie", "pediatrie", "gyneco_maternite",
  "neurologie", "orthopedie", "laboratoires", "pharmacies_garde",
];

export const SPONSORED_TIERS = ["none", "basic", "premium", "partner"];

export const HEALTH_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "category_id", label: "Catégorie ID", type: "select", options: HEALTH_CATS, required: true },
  { key: "category_label", label: "Catégorie (label)", type: "text", required: true },
  { key: "category_emoji", label: "Emoji catégorie", type: "text", maxLength: 4 },
  { key: "nom", label: "Nom établissement", type: "text", required: true, maxLength: 100 },
  { key: "type", label: "Type", type: "text" },
  { key: "categorie_etablissement", label: "Catégorie établissement", type: "text" },
  { key: "services_proposes", label: "Services proposés (CSV)", type: "csv" },
  { key: "commune", label: "Commune", type: "select", options: COMMUNES_CIV, required: true },
  { key: "adresse_textuelle", label: "Adresse", type: "text" },
  { key: "adresse_civ", label: "Adresse CIV", type: "text" },
  { key: "telephone", label: "Téléphone", type: "text" },
  { key: "telephone_urgence", label: "Téléphone urgence", type: "text" },
  { key: "horaires_complets", label: "Horaires", type: "text" },
  { key: "garde_actuelle", label: "Garde 24h", type: "select", options: ["true", "false"] },
  { key: "verified", label: "Vérifié", type: "select", options: ["true", "false"] },
  { key: "sponsored_tier", label: "Sponsorisé", type: "select", options: SPONSORED_TIERS },
  { key: "photo_url", label: "Photo URL", type: "text" },
  { key: "usp", label: "USP", type: "textarea" },
];

export const JUSTICE_CATS = [
  "avocats_penal", "avocats_civil", "avocats_affaires",
  "avocats_famille", "avocats_travail",
  "notaires", "huissiers", "tribunaux", "maisons_arret", "aide_juridique",
];

export const JUSTICE_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "category_id", label: "Catégorie ID", type: "select", options: JUSTICE_CATS, required: true },
  { key: "category_label", label: "Catégorie (label)", type: "text", required: true },
  { key: "category_emoji", label: "Emoji catégorie", type: "text", maxLength: 4 },
  { key: "nom", label: "Nom", type: "text", required: true, maxLength: 100 },
  { key: "specialite", label: "Spécialité", type: "text" },
  { key: "categorie", label: "Catégorie", type: "text" },
  { key: "commune", label: "Commune", type: "select", options: COMMUNES_CIV, required: true },
  { key: "adresse_textuelle", label: "Adresse", type: "text" },
  { key: "adresse_civ", label: "Adresse CIV", type: "text" },
  { key: "telephone", label: "Téléphone", type: "text" },
  { key: "email", label: "Email", type: "text" },
  { key: "annee_barreau", label: "Année barreau", type: "number", min: 1900, max: 2100 },
  { key: "annees_experience", label: "Années d'expérience", type: "number", min: 0, max: 80 },
  { key: "langues_parlees", label: "Langues parlées", type: "text" },
  { key: "honoraires_estimes", label: "Honoraires estimés", type: "text" },
  { key: "verified", label: "Vérifié", type: "select", options: ["true", "false"] },
  { key: "sponsored_tier", label: "Sponsorisé", type: "select", options: SPONSORED_TIERS },
  { key: "photo_url", label: "Photo URL", type: "text" },
  { key: "usp", label: "USP", type: "textarea" },
];

export const COMMERCES_CATS = ["boutique", "pharmacie", "restaurant", "autre"];

export const COMMERCES_SCHEMA = [
  { key: "id", label: "ID interne", readonly: true },
  { key: "id_etablissement", label: "ID établissement", readonly: true },
  { key: "nom", label: "Nom", type: "text", required: true, maxLength: 100 },
  { key: "categorie", label: "Catégorie", type: "select", options: COMMERCES_CATS, required: true },
  { key: "commune", label: "Commune", type: "select", options: COMMUNES_CIV, required: true },
  { key: "street_id", label: "Street ID", type: "text", placeholder: "PLA-001, YOP-001, …" },
  { key: "lng", label: "Longitude", type: "number", min: -180, max: 180, step: 0.000001, required: true },
  { key: "lat", label: "Latitude", type: "number", min: -90, max: 90, step: 0.000001, required: true },
  { key: "adresse_virtuelle", label: "Adresse virtuelle CIV (auto)", readonly: true },
  { key: "adresse_textuelle", label: "Adresse textuelle (auto)", readonly: true },
  { key: "metres_du_carrefour", label: "Mètres du carrefour (auto)", readonly: true },
  { key: "contact", label: "Contact", type: "text" },
  { key: "description_nouchi", label: "Description Nouchi", type: "textarea" },
  { key: "description", label: "Description", type: "textarea" },
];

// ─── v2.19.22e-3 — Stores legacy (Sponsored / Events / Partners) ──────────
export const SPONSORED_CATS = [
  "restauration", "sante", "justice", "finance", "administration",
  "shopping", "evenementiel", "transport", "telecom", "autre",
];

export const SPONSORED_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "nom", label: "Nom commercial", type: "text", required: true, maxLength: 120 },
  { key: "categorie", label: "Catégorie", type: "select", options: SPONSORED_CATS, required: true },
  { key: "sous_categorie", label: "Sous-catégorie", type: "text", placeholder: "ex: poulet_braise" },
  { key: "commune", label: "Commune", type: "select", options: COMMUNES_CIV },
  { key: "ville", label: "Ville", type: "text", placeholder: "Abidjan" },
  { key: "adresse", label: "Adresse", type: "text" },
  { key: "telephone", label: "Téléphone", type: "text" },
  { key: "prix_moyen_fcfa", label: "Prix moyen (FCFA)", type: "number", min: 0 },
  { key: "horaires", label: "Horaires", type: "text" },
  { key: "usp", label: "USP / Tagline", type: "textarea", maxLength: 300 },
  { key: "priority", label: "Priorité (1-10)", type: "number", min: 1, max: 10 },
  { key: "active", label: "Actif (true/false)", type: "select", options: ["true", "false"] },
];

export const EVENTS_CATS = [
  "sport", "festival", "degustation", "celebration", "anniversaire",
  "concert", "conference", "soiree", "religieux", "autre",
];

export const EVENTS_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "title", label: "Titre", type: "text", required: true, maxLength: 120 },
  { key: "sub_category", label: "Catégorie", type: "select", options: EVENTS_CATS, required: true },
  { key: "venue_name", label: "Lieu", type: "text", required: true },
  { key: "commune", label: "Commune", type: "select", options: COMMUNES_CIV },
  { key: "starts_at", label: "Début (ISO)", type: "text", placeholder: "2026-12-31T20:00:00Z", required: true },
  { key: "ends_at", label: "Fin (ISO)", type: "text", placeholder: "2026-12-31T23:30:00Z" },
  { key: "ticket_price_fcfa", label: "Prix billet (FCFA)", type: "number", min: 0 },
  { key: "status", label: "Statut", type: "select", options: ["active", "paused", "sold_out", "cancelled"] },
  { key: "address_civ", label: "Code CIV", type: "text" },
  { key: "lat", label: "Latitude", type: "number", min: -90, max: 90, step: 0.000001 },
  { key: "lng", label: "Longitude", type: "number", min: -180, max: 180, step: 0.000001 },
  { key: "whatsapp_contact", label: "WhatsApp contact", type: "text" },
  { key: "image_override", label: "Image URL", type: "text" },
  { key: "description", label: "Description", type: "textarea" },
];

export const PARTNERS_CATS = [
  "news", "mode", "beauté", "marché", "tech", "sport", "culture",
  "mobile_money", "business", "abidjan_vibes", "media", "ong",
  "institution", "entreprise", "autre",
];

export const PARTNERS_SCHEMA = [
  { key: "id", label: "ID", readonly: true },
  { key: "name", label: "Nom partenaire", type: "text", required: true, maxLength: 100 },
  { key: "category", label: "Catégorie", type: "select", options: PARTNERS_CATS, required: true },
  { key: "type", label: "Type", type: "text", placeholder: "newspaper, blog, brand…" },
  { key: "domain", label: "Domaine", type: "text", placeholder: "ex: rti.ci" },
  { key: "url", label: "URL", type: "text" },
  { key: "logo_url", label: "Logo URL", type: "text" },
  { key: "description", label: "Description", type: "textarea" },
  { key: "physical_address", label: "Adresse physique", type: "text" },
  { key: "premium_enabled", label: "Premium (true/false)", type: "select", options: ["true", "false"] },
  { key: "free_enabled", label: "Free (true/false)", type: "select", options: ["true", "false"] },
  { key: "active", label: "Actif (true/false)", type: "select", options: ["true", "false"] },
  { key: "enabled", label: "Enabled (true/false)", type: "select", options: ["true", "false"] },
];
